import {Component, Inject, OnInit, QueryList, ViewChild, ViewChildren,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  FileBlobService,
  ProjectControlItemService,
  ProjectService,
  UserService,
} from '../../_services/index';

import {AlertType, Project, ProjectControlItem, User} from '../../_models/index';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import {DatesHelper, ImplementationStatus, LoginHelper, Recurring, Role, StringsHelper} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import {IndexConfigService} from "../../_services/index.config.service";
import {SelectItem} from "primeng/api";
import {Policy} from "../../_models/policy";
import {PolicyService} from "../../_services/policy.service";
import {forkJoin} from "rxjs";

@Component({
    standalone: false,
  selector: "project-policies-component",
  templateUrl: 'projectPolicies.component.html',
  styleUrls: ['./projectPolicies.component.scss'],
})

export class ProjectPoliciesComponent implements OnInit {
  projectId: number;
  project: Project;
  selectedPolicy: Policy;
  projectControlItems: ProjectControlItem[];
  filteredProjectControlItems: ProjectControlItem[];
  remainingControlItems: ProjectControlItem[];
  filteredControlItems: any;
  assignedVendorUsers: User[];
  assignedNonVendorUsers: User[];
  rowGroupMetadata = {};
  currentUser: User;
  isVendor = false;
  policies: Policy[];
  expandedSmallItem = {};
  userToken = LoginHelper.getFileToken();
  recurringList: any[];
  categoryFilterOptions = [];
  anyAreaWithLevels = false;
  columnOptions: SelectItem[];
  columnVisibility: any = {
    'controlItem.level': false,
    'mapping': false,
    'targetMapping': false,
    'currentRangeCompleted': false,
    'reviewRequired': false,
  };
  isUserAdvisor = false;
  policyMap: any = {};

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public projectService: ProjectService,
    public projectControlItemService: ProjectControlItemService,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public policyService: PolicyService,
    public fileBlobService: FileBlobService,
    public userService: UserService,
    public clientProfileService: ClientProfileService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public config: IndexConfigService) {
    this.projectId = route.snapshot.params['projectId'];
    this.recurringList = [];
    for (let i = 0; i <= Recurring.Yearly; i++) {
      this.recurringList.push({label: Recurring[i].toString(), value: i});
    }
  }

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isVendor = this.currentUser.role == Role.Vendor;
    this.isUserAdvisor = (this.currentUser.role & (Role.AdvisorStaff | Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != null;
    this.categoryFilterOptions = [];
    this.loadProject();
  }

  loadProject() {
    const requests = [this.projectService.getById(this.projectId)];
    requests.push(this.clientProfileService.getUserSetting('ProjectTableNew'));

    if (!this.policies) {
      requests.push(this.policyService.getAllPolicys());
    }
    forkJoin(requests).subscribe(
      (data: any[]) => {
        this.project = data[0];
        if (data.length > 1) {
          this.policies = data[2] || [];
        }

        this.selectedPolicy = this.policies[0];
        this.columnVisibility = (data[1] || {}).columnVisibility || this.columnVisibility;
        this.columnOptions = [];

        this.filteredProjectControlItems = this.projectControlItems = this.project.projectControlItems.filter(i => !this.project.deniedUserCategoriesMap[this.currentUser.userId] || this.project.deniedUserCategoriesMap[this.currentUser.userId].indexOf(i.controlItem.category) < 0);

        this.projectControlItems.forEach(projectControlItem => {
          let i;
          this.policyMap[projectControlItem.projectControlItemId] = {};
          this.policies.forEach(p => {
            this.policyMap[projectControlItem.projectControlItemId][p.id] = (projectControlItem.projectControlItemPolicies || []).find(z => z.policyId === p.id);
          });
          this.anyAreaWithLevels = this.anyAreaWithLevels || projectControlItem.controlItem.complianceArea.hasLevels;
          const parent = this.projectControlItems.find(i => i.controlItem.controlItemId == projectControlItem.controlItem.parentControlItemId);
          if (parent) {
            (<any>projectControlItem).parentName = parent.controlItem.category + ' - ' + parent.controlItem.complianceAreaControlId;
          }
          (<any>projectControlItem).policies = projectControlItem.projectControlItemPolicies && projectControlItem.projectControlItemPolicies.length > 0 ? projectControlItem.projectControlItemPolicies.map(z => this.policies.find(p => p.id === z.policyId)).filter(i => i) : [];
          projectControlItem.assignedClient.fullName = projectControlItem.assignedClient.firstName + " " + projectControlItem.assignedClient.lastName;
          projectControlItem.subItems = this.projectControlItems.filter(i => i.controlItem.parentControlItemId == projectControlItem.controlItem.controlItemId && (!this.project.isPartner || i.assignedClientId == projectControlItem.assignedClientId))
            .sort((a, b) =>
              a.controlItem.level > b.controlItem.level ? 1 : a.controlItem.level < b.controlItem.level ? -1 :
                a.controlItem.complianceAreaControlId > b.controlItem.complianceAreaControlId ? 1 : -1);
          projectControlItem.subItemLevels = [];
          let currentLevel = "";
          for (i = 0; i < projectControlItem.subItems.length; i++) {
            projectControlItem.subItems[i].hasParent = true;
            if (projectControlItem.subItems[i].controlItem.level != currentLevel) {
              currentLevel = projectControlItem.subItems[i].controlItem.level;
              const newSubItemLevel = {subItems: [], level: currentLevel};
              projectControlItem.subItemLevels.push(newSubItemLevel);
            }
            projectControlItem.subItemLevels[projectControlItem.subItemLevels.length - 1].subItems.push(projectControlItem.subItems[i]);
          }
          projectControlItem.originalCompletionPeriods = JSON.parse(JSON.stringify(projectControlItem.completionPeriods));
          projectControlItem.originalreviewedByConsultantDates = Object.assign([], projectControlItem.reviewedByConsultantDates);

          this.assignedVendorUsers = this.project.assignedUsers.filter(u => u.role == Role.Vendor);
          this.assignedNonVendorUsers = this.project.assignedUsers.filter(u => u.role != Role.Vendor);

          if (!projectControlItem.attachments) {
            projectControlItem.attachments = [];
          } else {
            projectControlItem.attachments.forEach(a => {
              if (a.name.indexOf('document://') == 0) {
                (<any>a).fileName = a.name.split('\\').pop();
                let path = a.name.match(/^document:\/\/(.*)\\[^\\]*$/i)[1] || "";
                path = path === 'null' ? '\\' : path;
                (<any>a).url = this.config.api + '/api/attachments/file?token=' + LoginHelper.getFileToken() + '&name=' + encodeURIComponent((<any>a).fileName) + "&path=" + encodeURIComponent(path);
              }
            })
          }
          const controlOriginationQuestions = (projectControlItem.controlItem.controlOrigination || '').split('\n').map(q => q.replace('☐', '').trim()).filter(q => q);
          let oldValueParts = [];
          try {
            oldValueParts = JSON.parse(projectControlItem.controlOrigination || '[]');
          } catch (e) {
          }
          const controlOrigination = controlOriginationQuestions.map((q, i) => oldValueParts[i] || false);
          let isCr = !!controlOriginationQuestions.find((q, i) => controlOrigination[i] && q.toLowerCase().indexOf('customer') >= 0);
          let isParentCr = false;

          if (parent) {
            const parentControlOriginationQuestions = (parent.controlItem.controlOrigination || '').split('\n').map(q => q.replace('☐', '').trim()).filter(q => q);
            oldValueParts = [];
            try {
              oldValueParts = JSON.parse(parent.controlOrigination || '[]');
            } catch (e) {
            }
            const parentControlOrigination = parentControlOriginationQuestions.map((q, i) => oldValueParts[i] || false);
            isParentCr = !!parentControlOriginationQuestions.find((q, i) => parentControlOrigination[i] && q.toLowerCase().indexOf('customer') >= 0);
          }
        });

        this.regroupControlItems();
      },
      error => {
        const errorMessage = 'An error occurred while loading project.';
        this.alertService.error(errorMessage);
      });
  }

  regroupControlItems() {
    let i;
    this.filteredControlItems = {};
    this.remainingControlItems = [...this.filteredProjectControlItems/*.filter(i => !i.controlItem.parentControlItemId || this.filteredProjectControlItems.find(c => c.controlItem.controlItemId == i.controlItem.parentControlItemId))*/];
    if (this.assignedVendorUsers.length == 0) {
      this.updateRowGroupMetaData(this.remainingControlItems, "remainingControlItems");
      return;
    }
    for (i = 0; i < this.filteredProjectControlItems.length; i++) {
      if (this.filteredProjectControlItems[i].controlItem.parentControlItemId || this.projectControlItems.find(c => c.controlItem.controlItemId == this.filteredProjectControlItems[i].controlItem.parentControlItemId)) continue;
      if (this.assignedVendorUsers && this.assignedVendorUsers.find(u => this.projectControlItems[i].assignedClient.userId == u.userId)) {
        if (!this.filteredControlItems[this.filteredProjectControlItems[i].assignedClient.userId]) {
          this.filteredControlItems[this.filteredProjectControlItems[i].assignedClient.userId] = [];
        }
        this.filteredControlItems[this.filteredProjectControlItems[i].assignedClient.userId].push(this.filteredProjectControlItems[i]);
        if (this.remainingControlItems.indexOf(this.filteredProjectControlItems[i]) >= 0) {
          this.remainingControlItems = this.remainingControlItems.filter(t => t != this.filteredProjectControlItems[i]);
        }
      }
      if (this.assignedNonVendorUsers && this.assignedNonVendorUsers.find(u => this.filteredProjectControlItems[i].assignedClient.userId == u.userId)) {
        if (!this.filteredControlItems[this.filteredProjectControlItems[i].assignedClient.userId]) {
          this.filteredControlItems[this.filteredProjectControlItems[i].assignedClient.userId] = [];
        }
        this.filteredControlItems[this.filteredProjectControlItems[i].assignedClient.userId].push(this.filteredProjectControlItems[i]);
        if (this.remainingControlItems.indexOf(this.filteredProjectControlItems[i]) >= 0) {
          this.remainingControlItems = this.remainingControlItems.filter(t => t != this.filteredProjectControlItems[i]);
        }
      }
    }
    this.updateRowGroupMetaData(this.remainingControlItems, "remainingControlItems");
    for (i = 0; i < this.assignedNonVendorUsers.length; i++) {
      this.updateRowGroupMetaData(this.filteredControlItems[this.assignedNonVendorUsers[i].userId], this.assignedNonVendorUsers[i].userId);
    }
    for (i = 0; i < this.assignedVendorUsers.length; i++) {
      this.updateRowGroupMetaData(this.filteredControlItems[this.assignedVendorUsers[i].userId], this.assignedVendorUsers[i].userId);
    }

  }

  updateRowGroupMetaData(data, key) {
    this.rowGroupMetadata[key] = {};
    console.log("|u");
    console.log(data);
    if (data) {

      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.controlItem.category;
        if (i == 0) {
          this.rowGroupMetadata[key][brand] = {index: 0, size: 1, maturity: rowData.processMaturity};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.controlItem.category;
          if (brand === previousRowGroup) {
            this.rowGroupMetadata[key][brand].maturity += rowData.processMaturity;
            this.rowGroupMetadata[key][brand].size++;
          } else
            this.rowGroupMetadata[key][brand] = {index: i, size: 1, maturity: rowData.processMaturity};
        }
      }
    }
  }

  switchItem(event, item){
    if (this.selectedPolicy){
      this.projectControlItemService.switchPolicy(item.projectControlItemId, this.selectedPolicy.id, !this.policyMap[item.projectControlItemId][this.selectedPolicy.id]).subscribe(() => {
        this.policyMap[item.projectControlItemId][this.selectedPolicy.id] = !this.policyMap[item.projectControlItemId][this.selectedPolicy.id];
        this.alertService.alert(AlertType.Error, 'Successfully Saved');
      });
    }
  }
}
